export const defaultLatLng: [number, number] = [53.906_967_499_177_746, 27.567_293_647_483_91];

export const mapModalWidth = 958;
